import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import echarts from 'echarts'
import './plugins/element.js'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false;
Vue.use(VueLodash, {lodash: lodash});
Vue.prototype.$echarts = echarts

import App from './App.vue'
new Vue({
  render: h => h(App),
}).$mount('#app');
